import './cta.scss';

/**
 * Pick random CTA images in the browser so full-page caches stay valid.
 *
 * @param {number[]} indices Original indices.
 * @param {number}         take How many to pick.
 * @return {number[]} Picked indices.
 */
function junction_cta_pick_random_indices( indices, take ) {
	const pool = indices.slice();
	const out = [];
	const n = Math.min( take, pool.length );
	for ( let i = 0; i < n; i++ ) {
		const j = Math.floor( Math.random() * pool.length );
		out.push( pool[ j ] );
		pool.splice( j, 1 );
	}
	return out;
}

/**
 * Shuffle array copy (Fisher-Yates).
 *
 * @template T
 * @param {T[]} list Items.
 * @return {T[]} New shuffled array.
 */
function junction_cta_shuffle( list ) {
	const out = list.slice();
	for ( let i = out.length - 1; i > 0; i-- ) {
		const j = Math.floor( Math.random() * ( i + 1 ) );
		const t = out[ i ];
		out[ i ] = out[ j ];
		out[ j ] = t;
	}
	return out;
}

/**
 * Re-append children in given order (moves existing nodes).
 *
 * @param {HTMLElement}    wrap Parent.
 * @param {HTMLElement[]} order New order (must be same nodes as currently in wrap).
 */
function junction_cta_reorder_children( wrap, order ) {
	const frag = document.createDocumentFragment();
	order.forEach( ( el ) => {
		frag.appendChild( el );
	} );
	wrap.appendChild( frag );
}

function junction_init_cta_shuffle_only() {
	const wraps = document.querySelectorAll( '.m-cta__images--shuffle' );

	wraps.forEach( ( wrap ) => {
		const items = Array.from( wrap.querySelectorAll( '.m-cta__image' ) );
		if ( items.length < 2 ) {
			return;
		}
		junction_cta_reorder_children( wrap, junction_cta_shuffle( items ) );
	} );
}

function junction_init_cta_random_images() {
	const wraps = document.querySelectorAll( '.m-cta__images--random[data-cta-random]' );

	wraps.forEach( ( wrap ) => {
		const take = parseInt( wrap.getAttribute( 'data-cta-random' ), 10 ) || 3;
		const items = Array.from( wrap.querySelectorAll( '.m-cta__image' ) );

		if ( items.length <= take ) {
			return;
		}

		const pickedIdx = junction_cta_pick_random_indices(
			items.map( ( _, i ) => i ),
			take
		);
		const picked = new Set( pickedIdx );
		const pickedEls = pickedIdx.map( ( idx ) => items[ idx ] );
		const rest = items.filter( ( _, i ) => ! picked.has( i ) );
		const shuffledPicked = junction_cta_shuffle( pickedEls );

		junction_cta_reorder_children( wrap, shuffledPicked.concat( rest ) );

		shuffledPicked.forEach( ( el ) => {
			el.classList.add( '-visible' );
		} );

		wrap.classList.add( 'm-cta__images--picked' );
	} );
}

function junction_run_cta_images() {
	const run = () => {
		junction_init_cta_random_images();
		junction_init_cta_shuffle_only();
	};
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', run );
	} else {
		run();
	}
}

junction_run_cta_images();